<app-action-list
  [actions]="actions" 
  [showVersion]="showVersion" 
  [version]="version" 
  [disableWhenOffline]="disableWhenOffline" 
  [isOnline]="isOnline" 
  (onActionClick)="close(); onActionClickHandler($event);"></app-action-list
>